import { Component, inject, Input } from '@angular/core';
import { AddressDto, EError } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { AddresstourDto, DayOfWeek, ReminderDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { IReminderService, IReminderServiceToken } from 'projects/shared/lib/services/data/reminder/reminder-service.interface';
import { firstValueFrom } from 'rxjs';
import { DeliveryReminder } from './delivery-reminder.model';
import { ToastItem } from 'projects/shared/lib/components/shared/toast/item/toast-item.model';
import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import { IUserService, IUserServiceToken } from 'projects/shared/lib/services/data/user/user-service.interface';
import { ErrorCodeService } from 'projects/shared/lib/services/infrastructure/error-code.service';
import { IToastService, IToastServiceToken } from 'shared/services/ui/toast/toast-service.interface';
import { IAuthService, IAuthServiceToken } from 'shared/services/infrastructure/authentication/auth-service.interface';

@Component({
  selector: 'app-delivery-reminder',
  templateUrl: './delivery-reminder.component.html',
  standalone: false
})
export class DeliveryReminderComponent {
  @Input() public addresstour: AddresstourDto | undefined;
  @Input() public address: AddressDto | undefined;
  @Input() public index: number | undefined;
  private customerNumber: string | undefined;
  private userNumber: string | undefined;
  public dayList: DayOfWeek[] | undefined;
  public deliveryReminderList: DeliveryReminder[];
  public selectedDay: DayOfWeek | undefined;
  public sendSMS: boolean | undefined;
  public sendEmail: boolean | undefined;
  public smsTime: string | undefined;
  public mailTime: string | undefined;
  public deliveryDay: DayOfWeek | undefined;
  private deliveryDayOfWeek: string | undefined;
  public callDay: DayOfWeek | undefined;
  public hours = ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'];
  public hoursBeforeDeliveryDay = ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00'];
  private readonly reminderService: IReminderService = inject(IReminderServiceToken);
  private readonly authService: IAuthService = inject(IAuthServiceToken);
  private readonly userService: IUserService = inject(IUserServiceToken);
  private readonly toastService: IToastService = inject(IToastServiceToken);
  private reminderList: ReminderDto[] | undefined;
  public componentVisibleList: boolean[] = [];

  public constructor() {
    this.componentVisibleList.forEach(componentVisible => {
      componentVisible = false;
    });
    this.reminderList = [];
    this.deliveryReminderList = [];
    this.sendSMS = false;
    this.sendEmail = false;
  }

  async ngOnInit() {
    if (this.addresstour != undefined) {
      this.deliveryDay = this.addresstour.tourDay;
      this.deliveryDayOfWeek = DayOfWeek[this.deliveryDay];
      this.callDay = this.addresstour.callDay;
    }
    await this.getReminderDataAsync();
    this.populateDayList();
  }

  public toggleComponent(index: number) {
    this.componentVisibleList[index] = !this.componentVisibleList[index];
  }

  private populateDayList() {
    if (this.addresstour != undefined) {
      let daysToInclude = 5;
      let daysOfWeek = Object.values(DayOfWeek).filter(day => typeof day === 'number') as number[];
      let filteredDays = daysOfWeek.filter(day => day !== DayOfWeek.Saturday && day !== DayOfWeek.Sunday);

      let deliveryDay = this.addresstour.tourDay.valueOf();
      let deliveryDayIndex = filteredDays.indexOf(deliveryDay);

      if (deliveryDayIndex !== -1) {
        this.dayList = [];
        this.deliveryReminderList = [];

        let index = deliveryDayIndex + 1;
        let count = 0;

        while (count < daysToInclude) {
          if (index >= filteredDays.length) {
            index = 0;
          }

          this.deliveryReminderList.push(new DeliveryReminder({
            day: filteredDays[index],
            isBothDay: false,
            isMailDay: false,
            isSmsDay: false
          }));
          this.dayList.push(filteredDays[index]);
          index++;
          count++;
        }
      }

      this.deliveryReminderList.forEach(deliveryReminder => {
        this.getBoxStyle(deliveryReminder.day);
      });
    }
  }

  private async getReminderDataAsync() {
    let customerNumber = await firstValueFrom(this.authService.customerNumberChangedGet());
    let userNumber = await firstValueFrom(this.authService.userNumberChangedGet());
    this.customerNumber = customerNumber;
    this.userNumber = userNumber;
    this.reminderList = (await firstValueFrom(this.reminderService.reminderListGet({ customerNumber: customerNumber })))?.filter(r => r.deliveryDay == this.deliveryDayOfWeek);
  }

  public selectDay(day: DayOfWeek) {
    if (this.selectedDay !== day) {
      this.selectedDay = day;
      this.sendSMS = undefined;
      this.sendEmail = undefined;
      this.smsTime = undefined;
      this.mailTime = undefined;
      let reminder: ReminderDto | undefined;
      if (this.reminderList != undefined) {
        reminder = this.reminderList.find(r => r.mailDay == DayOfWeek[day] || r.smsDay == DayOfWeek[day]);
      }
      if (reminder != undefined) {
        this.selectedDay = day;
        if (DayOfWeek[day] == reminder.smsDay) {
          this.sendSMS = reminder?.useSms;
          this.smsTime = this.hours.find(h => h == reminder?.smsTime?.slice(0, 5));
        }
        if (DayOfWeek[day] == reminder.mailDay) {
          this.sendEmail = reminder?.useMail;
          this.mailTime = this.hours.find(h => h == reminder?.mailTime?.slice(0, 5));
        }
      }
    }
  }

  public isDayDisabled(day: DayOfWeek): boolean {
    if (day === this.deliveryDay) {
      return true;
    }

    if (this.callDay && this.deliveryDay && this.dayList) {
      let deliveryDayIndex = this.dayList.indexOf(this.deliveryDay);
      let callDayIndex = this.dayList.indexOf(this.callDay);

      if (callDayIndex > deliveryDayIndex) {
        return true;
      }
    }

    return false;
  }

  public async saveInputsAsync() {
    let reminder = new ReminderDto();
    reminder.smsDay = undefined;
    reminder.smsTime = undefined;
    reminder.mailDay = undefined;
    reminder.mailTime = undefined;
    reminder.useSms = false;
    reminder.useMail = false;
    let oldreminder = this.reminderList?.find(r => r.deliveryDay == this.deliveryDayOfWeek);
    if (oldreminder != undefined) {
      reminder = oldreminder;
    }
    await firstValueFrom(this.userService.userGet(this.userNumber)).then(
      async (queryResult) => {
        let user = queryResult.user;
        if (this.sendSMS && this.selectedDay != undefined) {
          if (user?.mobile != undefined) {
            reminder.smsDay = DayOfWeek[this.selectedDay];
            reminder.smsTime = this.smsTime;
            reminder.useSms = this.sendSMS;
          } else {
            this.toastService.toastItemAdd(new ToastItem({
              type: EToastItemType.Warning,
              title: $localize`:@@DeliveryReminderSaveNoMobileNumberTitel:Error`,
              message: $localize`:@@DeliveryReminderSaveNoMobileNumberMessage:Please enter your phone number first so that you can use the order reminder for SMS.`,
              code: ErrorCodeService.formatErrorCode(EError.F160011)
            }));
          }
        }
        if (oldreminder?.useSms == true && this.sendSMS == false) {
          reminder.smsDay = undefined;
          reminder.smsTime = undefined;
          reminder.useSms = false;
        }
        if (this.sendEmail && this.selectedDay != undefined) {
          if (user?.eMail != undefined) {
            reminder.mailDay = DayOfWeek[this.selectedDay];
            reminder.mailTime = this.mailTime;
            reminder.useMail = this.sendEmail;
          } else {
            this.toastService.toastItemAdd(new ToastItem({
              type: EToastItemType.Warning,
              title: $localize`:@@DeliveryReminderSaveNoMailTitel:Error`,
              message: $localize`:@@DeliveryReminderSaveNoMailMessage:Please enter your Mailaddress first so that you can use the order reminder for Mail.`,
              code: ErrorCodeService.formatErrorCode(EError.F160021)
            }));
          }
        }
        if (this.deliveryDay != undefined) {
          reminder.deliveryDay = DayOfWeek[this.deliveryDay];
        }
        if (oldreminder?.useMail == true && this.sendEmail == false) {
          reminder.mailDay = undefined;
          reminder.mailTime = undefined;
          reminder.useMail = false;
        }
        reminder.addressNumber = this.address?.addressIdentifier?.addressNumber;
        reminder.customerNumber = this.customerNumber;
        reminder.userNumber = this.userNumber;

        await firstValueFrom(this.reminderService.reminderSet(reminder)).then((result) => {
          if (result.reminderValidationResult?.isValid) {
            this.toastService.toastItemAdd(new ToastItem({
              type: EToastItemType.Success,
              title: $localize`:@@DeliveryReminderSaveSucceededTitel:Success`,
              message: $localize`:@@DeliveryReminderSaveSucceededMessage:Your reminder has been saved.`
            }));
            this.ngOnInit();
          }
        }).catch((ex) => {
          this.toastService.toastItemAdd(new ToastItem({
            type: EToastItemType.Danger,
            title: $localize`:@@DeliveryReminderSaveFailedTitel:Error`,
            message: $localize`:@@DeliveryReminderSaveFailedMessage:Your reminder could not been saved.`,
            code: JSON.parse(ex.response).errorCode
          }));
        });
      }
    ).catch(
      (ex) => {
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Warning,
          title: $localize`:@@DeliveryReminderSaveUserGetErrorTitel:Error`,
          message: $localize`:@@DeliveryReminderSaveUserGetErrorMessage:Could not get necessary informations.`,
          code: JSON.parse(ex.response).errorCode
        }));
      }
    );
  }

  private getBoxStyle(day: DayOfWeek) {
    let isSMSDay = this.isSMSSaved(day);
    let isEmailDay = this.isEmailSaved(day);
    let isBothDay = false;

    if (isSMSDay && isEmailDay) {
      isBothDay = true;
    }

    if (this.deliveryReminderList != undefined) {
      this.deliveryReminderList.forEach(deliverReminder => {
        if (deliverReminder.day == day) {
          deliverReminder.isBothDay = isBothDay;
          deliverReminder.isMailDay = isEmailDay;
          deliverReminder.isSmsDay = isSMSDay;
        }
      });
    }
  }

  private isSMSSaved(day: DayOfWeek): boolean {
    if (this.deliveryDay != undefined) {
      let deliveryDayString = DayOfWeek[this.deliveryDay];
      let savedInput = this.reminderList?.find(input => input.smsDay === DayOfWeek[day] && input.deliveryDay != undefined && input.deliveryDay == deliveryDayString);
      return savedInput != undefined ? true : false;
    }
    return false;
  }

  private isEmailSaved(day: DayOfWeek): boolean {
    if (this.deliveryDay != undefined) {
      let deliveryDayString = DayOfWeek[this.deliveryDay];
      let savedInput = this.reminderList?.find(input => input.mailDay === DayOfWeek[day] && input.deliveryDay != undefined && input.deliveryDay == deliveryDayString);
      return savedInput != undefined ? true : false;
    }
    return false;
  }
}
